module.exports = __webpack_public_path__ + "media/Wir vermissen.ec49c31b.mp3";